import { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import _ from "lodash";
import icon from "assets/images/tw/tw-icon.png";
import mystryWord from "assets/images/tw/mystry-word.png";
import yourClue from "assets/images/tw/your-clue.png";
import pleaseWait from "assets/images/tw/please-wait.png";
import GuessedWord from "../components/GuessedWord";
import TWWaitingScreen from "../components/TWWaitingScreen";
import {
  divVariants,
  fade_bounce_delay_variants,
  bounce_right_to_left_variants_without_children,
  bounce_right_to_left_variants
} from "shared/components/animations";

const TWClues = ({
  word,
  roomId,
  currentPlayer,
  clueSubmitted,
  joke,
  isActivePlayer,
  screens,
  buzzer_sound,
  default_audio_effect
}) => {
  const active_player_word = _.get(
    screens,
    "waiting_clues.content",
    "You're the active player"
  );
  const active_player_description = _.get(
    screens,
    "waiting_clues.instructions",
    "YOU'RE UP! HANG TIGHT WHILE PEOPLE COME UP WITH THEIR CLUES!"
  );
  const waiting_others_description = _.get(
    screens,
    "waiting_others.instructions",
    "WAITING FOR OTHERS.."
  );
  const word_entry_clues_placeholder = _.get(
    screens,
    "word_entry_clues.hint",
    "Enter Your Clue Here"
  );
  const word_entry_clues_rule_heading = _.get(
    screens,
    "word_entry_clues.rule_heading",
    "Remember the Rules"
  );
  const word_entry_clues_button_text = _.get(
    screens,
    "word_entry_clues.button_text",
    "Submit"
  );
  const word_entry_clues_rules = _.get(screens, "word_entry_clues.rules", []);
  const [clue, setClue] = useState("");

  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "");
    setClue(inputValue);
  };

  const buttonPressAction = () => {
    if (!_.isEmpty(clue)) {
      const data = {
        action: "submit-clue",
        roomId,
        clue,
        playerId: currentPlayer?.player_id
      };

      Socket.sendMessage(data);
    }
  };

  const handleSubmit = useCallback(
    _.debounce(() => buttonPressAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [clue]
  );

  useEffect(() => {
    if (
      !isActivePlayer &&
      !_.isEmpty(default_audio_effect) &&
      _.isEmpty(clueSubmitted)
    ) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);

  return (
    <motion.section
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`tw-clues ${isActivePlayer ? "active-player" : ""}`}
    >
      <div
        className={`word-entry ${!_.isEmpty(clueSubmitted) ? "funfact" : ""}`}
      >
        {isActivePlayer ? (
          <TWWaitingScreen
            image={pleaseWait}
            guessWord={active_player_word}
            joke={joke}
            description={active_player_description}
          />
        ) : !_.isEmpty(clueSubmitted) ? (
          <TWWaitingScreen
            joke={joke}
            description={waiting_others_description}
            image={yourClue}
            guessWord={clueSubmitted?.word}
          />
        ) : (
          <motion.div variants={bounce_right_to_left_variants_without_children}>
            <GuessedWord image={mystryWord} word={word} />
            <input
              type="text"
              name="clue"
              className="input-field"
              placeholder={word_entry_clues_placeholder}
              value={clue}
              onChange={handleChange}
            />
            <div className="rules">
              <>
                <motion.h4
                  variants={bounce_right_to_left_variants}
                  className="text"
                >
                  {word_entry_clues_rule_heading}
                </motion.h4>
                <motion.ul variants={fade_bounce_delay_variants}>
                  {word_entry_clues_rules?.map((rule, index) => (
                    <li key={index}>
                      <img src={icon} alt="icon" />
                      {rule}
                    </li>
                  ))}
                </motion.ul>
              </>
            </div>
          </motion.div>
        )}
        {_.isEmpty(clueSubmitted) && !isActivePlayer && (
          <motion.div
            variants={bounce_right_to_left_variants_without_children}
            className="tw-btn-wrapper"
          >
            <div className="tw-btn" onClick={handleSubmit}>
              {word_entry_clues_button_text}
            </div>
          </motion.div>
        )}
      </div>
    </motion.section>
  );
};

export default TWClues;
